import { BaseSystemModel, RecursivePartial } from "@models/base";
import { DeviceInfo } from "@models/shared/device-info";

export class UserSession extends BaseSystemModel {
    deviceInfo?: DeviceInfo;
    ipAddress?: string;

    constructor(json?: RecursivePartial<UserSession>) {
        super(json);
        this.parseUserSession(json || {});
    }

    parse(json: RecursivePartial<UserSession>): UserSession {
        super.parse(json);
        this.parseUserSession(json);
        return this;
    }

    private parseUserSession(json: RecursivePartial<UserSession>): void {
        UserSession.assignFields(this, json, ['ipAddress']);
        UserSession.assignClassFields(this, json, { deviceInfo: DeviceInfo });
    }
}
